<!-- =========================================================================================
  File Name: UserList.vue
  Description: User List page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="page-user-list">
    <div class="vx-row">
      <!-- Draw Card -->
      <div v-if="action" class="vx-col w-full lg:w-2/3 xl:w-2/4 sm:w-full">
        <div
          class="vx-card p-5"
          :style="isSmallerScreen ? '' : `height: 75vh`"
          style="overflow-y: auto; padding: 0px"
        >
          <div class="vx-row mb-5">
            <div class="vx-col w-full">
              <h3 style="font-size: 16px; text-align: center">Order Data</h3>
            </div>
          </div>

          <div class="vx-row">
            <div v-if="actor.privilege < 4" class="vx-col w-full mb-3">
              <label class="vs-input--label">User</label>
              <v-select
                @search="searchGeneral"
                :clearable="false"
                :options="userList"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                v-model="input.user_id"
                placeholder="-- Select User --"
              />
            </div>
          </div>

          <div class="vx-row">
            <div class="vx-col md:w-1/2 sm:w-1/2 w-full mb-3">
              <vs-input
                label="Order No."
                class="w-full"
                v-model="input.order_no"
              />
            </div>

            <div class="vx-col md:w-1/2 sm:w-1/2 w-full mb-3">
              <label class="vs-input--label">Order Date </label>
              <br v-if="isSmallerScreen" />
              <flat-pickr
                :config="{
                  enableTime: true,
                  dateFormat: 'Y-m-d H:i',
                  time_24hr: true,
                  defaultHour: 0
                }"
                style="width: 100%"
                v-model="input.order_date"
              />
            </div>

            <div class="vx-col md:w-1/2 sm:w-1/2 w-full mb-3">
              <label class="vs-input--label">Device</label>
              <v-select
                :options="deviceList"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                v-model="input.imei"
                :disabled="!(actor.privilege == 4 || this.input.user_id != '')"
                @search="searchDevice"
                class="mb-4 md:mb-0"
                placeholder="-- Select Device --"
              />
            </div>

            <div class="vx-col md:w-1/2 sm:w-1/2 w-full mb-3">
              <label class="vs-input--label">Driver</label>
              <v-select
                :clearable="false"
                :options="driverList"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                v-model="input.driver_id"
                placeholder="-- Select Driver --"
              />
            </div>

            <div class="vx-col md:w-1/2 sm:w-1/2 w-full mb-3">
              <label class="vs-input--label">Route</label>
              <v-select
                :clearable="true"
                :options="routeList"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                v-model="input.route"
                placeholder="-- Select Route --"
              />
            </div>

            <div class="vx-col md:w-1/2 sm:w-1/2 w-full mb-3">
              <label class="vs-input--label">Customer</label>
              <v-select
                :clearable="false"
                :options="customerList"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                v-model="input.customer"
                placeholder="-- Select Customer --"
              />
            </div>

            <div class="vx-col md:w-1/2 sm:w-1/2 w-full mb-3">
              <label class="vs-input--label">Date Departure Planed</label>
              <flat-pickr
                :config="{
                  enableTime: true,
                  dateFormat: 'Y-m-d H:i',
                  time_24hr: true,
                  defaultHour: 0
                }"
                style="width: 100%"
                v-model="input.date_departure_planed"
              />
            </div>

            <div class="vx-col md:w-1/2 sm:w-1/2 w-full mb-3">
              <label class="vs-input--label">Date Arrival Planed</label>
              <flat-pickr
                :config="{
                  enableTime: true,
                  dateFormat: 'Y-m-d H:i',
                  time_24hr: true,
                  defaultHour: 0
                }"
                style="width: 100%"
                v-model="input.date_arrival_planed"
              />
            </div>
          </div>

          <div class="vx-row mt-6">
            <div class="vx-col w-full">
              <h3 style="font-size: 16px; text-align: center">Detail Data</h3>
            </div>
          </div>

          <div class="pickup-drop-card mt-6">
            <div class="vx-row">
              <div class="vx-col md:w-1/2 sm:w-1/2 w-full mb-3">
                <vs-input label="Item" class="w-full" v-model="input.item" />
              </div>

              <div class="vx-col md:w-1/2 sm:w-1/2 w-full mb-3">
                <vs-input
                  label="Quantity"
                  class="w-full"
                  type="number"
                  v-model="input.quantity"
                />
              </div>

              <div class="vx-col md:w-1/2 sm:w-1/2 w-full mb-3">
                <label class="vs-input--label">Set Pickup</label>
                <v-select
                  :clearable="false"
                  :options="poiList_pickup"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                  v-model="input.pickup_id"
                  placeholder="-- Select Pickup --"
                />
              </div>

              <div class="vx-col md:w-1/2 sm:w-1/2 w-full mb-3">
                <label class="vs-input--label">Set Drop</label>
                <v-select
                  :clearable="false"
                  :options="poiList_drop"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                  v-model="input.drop_id"
                  placeholder="-- Select Drop --"
                />
              </div>

              <div class="vx-col md:w-1/2 sm:w-1/2 w-full mb-3">
                <label class="vs-input--label">Note</label>
                <vs-textarea class="w-full" rows="3" v-model="input.note" />
              </div>
            </div>
          </div>

          <div class="flex mt-6">
            <vs-button
              @click="cancel"
              size="small"
              color="danger"
              icon-pack="feather"
              icon="icon-x"
              class="mr-2 mt-2 btn-custom"
            >
              <span class="align-middle">{{
                action == 'add' ? 'Cancel' : 'Close'
              }}</span>
            </vs-button>
            <vs-button
              v-if="action == 'add'"
              id="submitBtn"
              class="vs-con-loading__container mr-2 mt-2 btn-custom"
              @click="submit"
              size="small"
              :color="action == 'add' ? 'success' : 'primary'"
              icon-pack="feather"
              icon="icon-check"
            >
              <span class="align-middle">Submit</span>
            </vs-button>
          </div>
        </div>
      </div>

      <!-- Default Card -->
      <div v-else class="vx-col w-full lg:w-2/3 xl:w-2/4 sm:w-full">
        <div class="vx-card p-5">
          <!-- <h3 class="sidebar-title">Order List</h3> -->

          <vx-card
            ref="filterCard"
            title="Order List"
            class="user-list-filters mb-8"
          >
            <div class="vx-row">
              <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
                <label class="text-sm opacity-75">Device</label>
                <v-select
                  :options="deviceList"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                  v-model="filter.device"
                  @search="searchDevice"
                  class="mb-2 md:mb-0"
                />
              </div>
              <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
                <label class="text-sm opacity-75">Filter</label>
                <v-select
                  :options="dateList"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                  v-model="filter.dateOption"
                  class="mb-2 md:mb-0"
                />
              </div>
              <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
                <label class="vs-input--label">Start Date</label>
                <flat-pickr
                  :disabled="disableDate"
                  :config="{
                    enableTime: true,
                    dateFormat: 'Y-m-d H:i',
                    maxDate: maxDate,
                    time_24hr: true,
                    defaultHour: 0
                  }"
                  style="width: 100%"
                  v-model="filter.start_date"
                />
              </div>
              <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
                <label class="vs-input--label">End Date</label>
                <flat-pickr
                  :disabled="disableDate"
                  :config="{
                    enableTime: true,
                    dateFormat: 'Y-m-d H:i',
                    maxDate: maxDate,
                    time_24hr: true,
                    defaultHour: 23,
                    defaultMinute: 59
                  }"
                  style="width: 100%"
                  v-model="filter.end_date"
                />
              </div>
              <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
                <label class="vs-input--label">Status</label>
                <v-select
                  :options="statusList"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                  v-model="filter.status"
                  class="mb-2 md:mb-0"
                />
              </div>
              <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
                <vs-button
                  id="searchBtn"
                  style="width: 100%"
                  color="success"
                  type="filled"
                  icon-pack="feather"
                  icon="icon-search"
                  class="pl-5 mt-1 vs-con-loading__container"
                  :disabled="loading"
                  @click="search"
                  >Search</vs-button
                >
              </div>
            </div>
          </vx-card>

          <div class="flex flex-wrap items-center">
            <div class="flex-grow">
              <vs-button
                v-if="actor.privilege == 4"
                color="primary"
                type="gradient"
                class="mb-4 md:mb-0"
                @click="add"
                >Create Order</vs-button
              >
            </div>

            <vs-dropdown vs-trigger-click class="cursor-pointer mr-2">
              <div
                class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
              >
                <span class="mr-2"
                  >{{ page * per_page - (per_page - 1) }} -
                  {{
                    row_total - page * per_page > 0
                      ? page * per_page
                      : row_total
                  }}
                  of {{ row_total }}</span
                >
                <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
              </div>
              <vs-dropdown-menu>
                <vs-dropdown-item @click="updatePerPage(10)">
                  <span>10</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="updatePerPage(25)">
                  <span>25</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="updatePerPage(50)">
                  <span>50</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="updatePerPage(100)">
                  <span>100</span>
                </vs-dropdown-item>
              </vs-dropdown-menu>
            </vs-dropdown>

            <vs-input
              class="mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4"
              v-model="keyword"
              @keyup="search"
              placeholder="Search..."
            />
          </div>
          <div class="table-container">
            <!-- <vs-button @click="add()" size="small" class="mr-2 mt-2 btn-custom"
              >Create Order</vs-button
            > -->

            <table class="sidebar-table">
              <thead>
                <tr>
                  <th style="min-width: 15px">&nbsp;</th>
                  <th>Order No</th>
                  <th>Trip No</th>
                  <th>Device</th>
                  <th>Driver</th>
                  <th>Order Date</th>
                  <th>Distance</th>
                  <th>Status</th>
                  <th>#</th>
                </tr>
              </thead>
              <tbody v-if="data.length > 0">
                <tr v-for="(item, index) in data" :key="index">
                  <td>
                    <vs-checkbox
                      icon-pack="feather"
                      icon="icon-map-pin"
                      color="rgb(38, 187, 174)"
                      v-model="selected"
                      :vs-value="item.id"
                      @click="check(item, $event)"
                    ></vs-checkbox>
                  </td>
                  <td>{{ item.order_no }}</td>
                  <td>{{ item.trip_no }}</td>
                  <td>{{ item.gps ? item.gps.plate : '' }}</td>
                  <td>{{ item.driver.name }}</td>
                  <td>{{ item.order_date }}</td>
                  <td>
                    {{
                      item.end_mileage == 0
                        ? 0
                        : ((item.end_mileage - item.start_mileage) / 1000)
                            .toFixed(2)
                            .toString()
                            .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                    }}
                    Km
                  </td>
                  <td
                    :style="`font-weight:600; color:${
                      color_status[item.status.id]
                    }`"
                  >
                    {{ item.status.status_name }}
                  </td>
                  <td>
                    <vs-dropdown vs-trigger-click>
                      <vs-button
                        radius
                        color="dark"
                        type="flat"
                        icon-pack="feather"
                        icon="icon-settings"
                      ></vs-button>
                      <vs-dropdown-menu>
                        <vs-dropdown-item
                          v-if="actor.privilege == 4"
                          @click="finish_time(item)"
                          >Finish&nbsp;Time</vs-dropdown-item
                        >
                        <vs-dropdown-item @click="detail(item)"
                          >Show&nbsp;Detail</vs-dropdown-item
                        >
                        <vs-dropdown-item
                          v-if="actor.privilege == 4"
                          @click="del(item.id)"
                          >Delete</vs-dropdown-item
                        >
                      </vs-dropdown-menu>
                    </vs-dropdown>
                  </td>
                </tr>
              </tbody>
              <tbody v-else>
                <tr>
                  <td
                    v-if="loading"
                    colspan="8"
                    class="text-center"
                    style="padding: 10px; border-right: none"
                  >
                    <vs-icon icon-pack="feather" icon="icon-loader"></vs-icon>
                    Loading....
                  </td>
                  <td
                    v-else
                    colspan="8"
                    class="text-center"
                    style="padding: 10px; border-right: none"
                  >
                    No Data Available
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <vs-pagination
            style="margin-top: 20px"
            color="rgb(38, 187, 174)"
            :total="n_page"
            v-model="page"
          ></vs-pagination>
        </div>
      </div>
      <div class="vx-col w-full lg:w-1/3 xl:w-2/4 sm:w-full">
        <div
          class="vx-card p-3"
          :style="isSmallerScreen ? `height: 82vh` : `height: 75vh`"
        >
          <editable-map
            editable
            id="map"
            ref="map"
            :center.sync="map.center"
            :zoom="map.zoom"
            :options="mapOptions"
            style="min-height: 100px"
          >
            <!-- <l-control-polyline-measure :options="{ showUnitControl: false }" position="topleft"/> -->
            <l-control-layers position="topright"></l-control-layers>
            <l-tile-layer
              v-for="tileProvider in tileProviders"
              :key="tileProvider.name"
              :name="tileProvider.name"
              :visible="tileProvider.visible"
              :url="tileProvider.url"
              :attribution="tileProvider.attribution"
              layer-type="base"
            />
            <l-polyline
              v-for="item in polylines_show"
              :key="item.id"
              color="blue"
              :fillColor="item.color"
              :lat-lngs="item.latlngs"
              :visible="item.visible"
            ></l-polyline>

            <l-marker
              v-for="(item, index) in list_vehicle"
              :key="index + '_list_vehicle'"
              :lat-lng="item.latlngs"
              :visible="item.visible"
              :icon="item.icon"
            >
              <l-tooltip
                :options="{
                  permanent: true,
                  interactive: true,
                  direction: 'right'
                }"
                >{{ item.name }}</l-tooltip
              >
            </l-marker>

            <l-polygon
              v-for="(item, index) in polygons_pickup_show"
              :key="index + '_polygons_show_pickup'"
              :lat-lngs="item.latlngs"
              :color="'green'"
              :visible="item.visible"
            >
              <l-popup>
                <table
                  class="leaflet-popup-table"
                  style="padding: 10px; font-weight: 600"
                >
                  <tr>
                    <td>{{ item.name }}</td>
                  </tr>
                </table>
              </l-popup>
            </l-polygon>
            <l-marker
              v-for="(item, index) in markers_pickup_show"
              :key="index + '_markers_show_pickup'"
              :lat-lng="item.latlngs"
              :visible="item.visible"
              :icon="item.icon"
            >
              <l-tooltip
                :options="{
                  permanent: true,
                  interactive: true,
                  direction: 'right'
                }"
                >{{ item.name }}</l-tooltip
              >
            </l-marker>

            <l-polygon
              v-for="(item, index) in polygons_drop_show"
              :key="index + '_polygons_show_drop'"
              :lat-lngs="item.latlngs"
              :color="'red'"
              :visible="item.visible"
            >
              <l-popup>
                <table
                  class="leaflet-popup-table"
                  style="padding: 10px; font-weight: 600"
                >
                  <tr>
                    <td>{{ item.name }}</td>
                  </tr>
                </table>
              </l-popup>
            </l-polygon>
            <l-marker
              v-for="(item, index) in markers_drop_show"
              :key="index + '_markers_show_drop'"
              :lat-lng="item.latlngs"
              :visible="item.visible"
              :icon="item.icon"
            >
              <l-tooltip
                :options="{
                  permanent: true,
                  interactive: true,
                  direction: 'right'
                }"
                >{{ item.name }}</l-tooltip
              >
            </l-marker>

            <l-polyline
              v-for="item in polylines"
              :key="item.id"
              color="blue"
              :fillColor="item.color"
              :lat-lngs="item.latlngs"
              :visible="item.visible"
            ></l-polyline>
            <div>
              <l-polygon
                v-for="(item, index) in polygons_selected_pickup"
                :key="index"
                :lat-lngs="item.latlngs"
                :color="item.slug.indexOf('pickup') != -1 ? 'green' : 'red'"
                :visible="item.visible"
              ></l-polygon>
              <l-marker
                v-for="(item, index) in markers_selected_pickup"
                :key="index"
                :lat-lng="item.latlngs"
                :visible="item.visible"
                :icon="item.icon"
              >
                <l-tooltip
                  :options="{
                    permanent: true,
                    interactive: true,
                    direction: 'right'
                  }"
                  >{{ item.name }}</l-tooltip
                >
              </l-marker>

              <l-polygon
                v-for="(item, index) in polygons_selected_drop"
                :key="index + 2"
                :lat-lngs="item.latlngs"
                :color="item.slug.indexOf('pickup') != -1 ? 'green' : 'red'"
                :visible="item.visible"
              ></l-polygon>
              <l-marker
                v-for="(item, index) in markers_selected_drop"
                :key="index + 2"
                :lat-lng="item.latlngs"
                :visible="item.visible"
                :icon="item.icon"
              >
                <l-tooltip
                  :options="{
                    permanent: true,
                    interactive: true,
                    direction: 'right'
                  }"
                  >{{ item.name }}</l-tooltip
                >
              </l-marker>
            </div>

            <!-- <editable-polyline editable :lat-lngs="editPolyline"></editable-polyline> -->
          </editable-map>
        </div>
      </div>
    </div>

    <vs-popup
      classContent="popup-example"
      :title="popupTitle"
      style="z-index: 51999"
      :active.sync="showPopup"
    >
      <div class="vx-row mb-5">
        <div class="vx-col md:w-1/2 sm:w-1/2 w-full mb-3">
          <label class="vs-input--label">Loading Date </label>
          <flat-pickr
            :config="{
              enableTime: true,
              dateFormat: 'Y-m-d H:i',
              time_24hr: true,
              defaultHour: 0
            }"
            style="width: 100%"
            v-model="finish.loading_date"
          />
        </div>
        <div class="vx-col md:w-1/2 sm:w-1/2 w-full mb-3">
          <label class="vs-input--label">Depart Date </label>
          <flat-pickr
            :config="{
              enableTime: true,
              dateFormat: 'Y-m-d H:i',
              time_24hr: true,
              defaultHour: 0
            }"
            style="width: 100%"
            v-model="finish.depart_date"
          />
        </div>
        <div class="vx-col md:w-1/2 sm:w-1/2 w-full mb-3">
          <label class="vs-input--label">Arrive Date </label>
          <flat-pickr
            :config="{
              enableTime: true,
              dateFormat: 'Y-m-d H:i',
              time_24hr: true,
              defaultHour: 0
            }"
            style="width: 100%"
            v-model="finish.arrive_date"
          />
        </div>
        <div class="vx-col md:w-1/2 sm:w-1/2 w-full mb-3">
          <label class="vs-input--label">Unloading Date </label>
          <flat-pickr
            :config="{
              enableTime: true,
              dateFormat: 'Y-m-d H:i',
              time_24hr: true,
              defaultHour: 0
            }"
            style="width: 100%"
            v-model="finish.unloading_date"
          />
        </div>
        <div class="vx-col md:w-1/2 sm:w-1/2 w-full mb-3">
          <label class="vs-input--label">Finish Date </label>
          <flat-pickr
            :config="{
              enableTime: true,
              dateFormat: 'Y-m-d H:i',
              time_24hr: true,
              defaultHour: 0
            }"
            style="width: 100%"
            v-model="finish.finish_date"
          />
        </div>
      </div>

      <div class="vx-row">
        <div class="vx-col w-full ml-auto">
          <vs-button
            id="submitBtn"
            class="mr-3 mb-2 vs-con-loading__container"
            @click="updateFinishTime"
            >Force Update</vs-button
          >
        </div>
      </div>
    </vs-popup>

    <vs-popup
      classContent="popup-example"
      :title="popupTitle"
      style="z-index: 51999"
      :active.sync="showPopupDetail"
    >
      <div class="vx-row mb-5">
        <div class="vx-col md:w-1/2 sm:w-1/2 w-full">
          <vs-input
            label="Order No"
            class="w-full"
            type="text"
            disabled
            v-model="show_detail.order_no"
          />
        </div>
        <div class="vx-col md:w-1/2 sm:w-1/2 w-full">
          <vs-input
            label="Order Date"
            class="w-full"
            type="text"
            disabled
            v-model="show_detail.order_date"
          />
        </div>
        <div class="vx-col md:w-1/2 sm:w-1/2 w-full">
          <vs-input
            label="Device"
            class="w-full"
            type="text"
            disabled
            v-model="show_detail.imei"
          />
        </div>
        <div class="vx-col md:w-1/2 sm:w-1/2 w-full">
          <vs-input
            label="Driver"
            class="w-full"
            type="text"
            disabled
            v-model="show_detail.driver_id"
          />
        </div>
        <div class="vx-col md:w-1/2 sm:w-1/2 w-full">
          <vs-input
            label="Date Departure Planed"
            class="w-full"
            type="text"
            disabled
            v-model="show_detail.date_departure_planed"
          />
        </div>
        <div class="vx-col md:w-1/2 sm:w-1/2 w-full">
          <vs-input
            label="Date Arrival Planed"
            class="w-full"
            type="text"
            disabled
            v-model="show_detail.date_arrival_planed"
          />
        </div>
        <div class="vx-col md:w-1/2 sm:w-1/2 w-full">
          <vs-input
            label="Status"
            class="w-full"
            type="text"
            disabled
            v-model="show_detail.status"
          />
        </div>
        <div class="vx-col md:w-1/2 sm:w-1/2 w-full">
          <vs-input
            label="Route"
            class="w-full"
            type="text"
            disabled
            v-model="show_detail.route"
          />
        </div>
        <div class="vx-col md:w-1/2 sm:w-1/2 w-full">
          <vs-input
            label="Customer"
            class="w-full"
            type="text"
            disabled
            v-model="show_detail.customer"
          />
        </div>
        <div class="vx-col md:w-1/2 sm:w-1/2 w-full">
          <vs-input
            label="Item"
            class="w-full"
            type="text"
            disabled
            v-model="show_detail.item"
          />
        </div>
        <div class="vx-col md:w-1/2 sm:w-1/2 w-full">
          <vs-input
            label="Quantity"
            class="w-full"
            type="text"
            disabled
            v-model="show_detail.quantity"
          />
        </div>
        <div class="vx-col md:w-1/2 sm:w-1/2 w-full">
          <vs-input
            label="Set Pickup"
            class="w-full"
            type="text"
            disabled
            v-model="show_detail.pickup"
          />
        </div>
        <div class="vx-col md:w-1/2 sm:w-1/2 w-full">
          <vs-input
            label="Set Drop"
            class="w-full"
            type="text"
            disabled
            v-model="show_detail.drop"
          />
        </div>
        <div class="vx-col md:w-1/2 sm:w-1/2 w-full">
          <vs-input
            label="Load Date"
            class="w-full"
            type="text"
            disabled
            v-model="show_detail.load_date"
          />
        </div>
        <div class="vx-col md:w-1/2 sm:w-1/2 w-full">
          <vs-input
            label="Depart Date"
            class="w-full"
            type="text"
            disabled
            v-model="show_detail.depart_date"
          />
        </div>
        <div class="vx-col md:w-1/2 sm:w-1/2 w-full">
          <vs-input
            label="Arrival Date"
            class="w-full"
            type="text"
            disabled
            v-model="show_detail.arrival_date"
          />
        </div>
        <div class="vx-col md:w-1/2 sm:w-1/2 w-full">
          <vs-input
            label="Unloading Date"
            class="w-full"
            type="text"
            disabled
            v-model="show_detail.unload_date"
          />
        </div>
        <div class="vx-col md:w-1/2 sm:w-1/2 w-full">
          <vs-input
            label="Finish Date"
            class="w-full"
            type="text"
            disabled
            v-model="show_detail.finish_date"
          />
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col w-full">
          <vs-textarea
            label="Note"
            class="w-full"
            rows="3"
            disabled
            v-model="show_detail.note"
          />
        </div>
      </div>
    </vs-popup>
  </div>
</template>

<style lang="scss" scoped>
.pickup-drop-card {
  margin-top: 10px;
  width: 92%;
  margin-left: auto;
  margin-right: auto;
  border: 1px solid teal;
  padding: 10px;
}
</style>

<script>
import L from 'leaflet'
import {
  LMap,
  LTileLayer,
  LMarker,
  LPolygon,
  LTooltip,
  LControlLayers,
  LPolyline,
  LPopup
} from 'vue2-leaflet'
// import LControlPolylineMeasure from 'vue2-leaflet-polyline-measure'
import { EditableMap } from 'vue2-leaflet-editable'
import vSelect from 'vue-select'
import 'leaflet-draw'

import 'leaflet/dist/leaflet.css'
import 'leaflet-draw/dist/leaflet.draw.css'

import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'

delete L.Icon.Default.prototype._getIconUrl
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png')
})

export default {
  components: {
    vSelect,
    LMap,
    LTileLayer,
    LMarker,
    LPolygon,
    LPolyline,
    LTooltip,
    LControlLayers,
    EditableMap,
    flatPickr,
    LPopup
  },

  data() {
    return {
      color: ['green', 'blue', 'teal', 'orange', 'red', 'purple', 'yellow'],
      data: [],
      actor: {},
      token: '',
      tileProviders: [
        {
          name: 'Google Street',
          visible: true,
          url: 'https://www.google.com/maps/vt?lyrs=m@189&gl=en&x={x}&y={y}&z={z}',
          attribution: 'google'
        },
        {
          name: 'Google Satellites',
          visible: false,
          url: 'https://www.google.com/maps/vt?lyrs=s@189&gl=en&x={x}&y={y}&z={z}',
          attribution: 'google'
        },
        {
          name: 'Google Hybrid',
          visible: false,
          url: 'https://www.google.com/maps/vt?lyrs=s,h@189&gl=en&x={x}&y={y}&z={z}',
          attribution: 'google'
        },
        {
          name: 'Google Terrain',
          visible: false,
          url: 'https://www.google.com/maps/vt?lyrs=p@189&gl=en&x={x}&y={y}&z={z}',
          attribution: 'google'
        },
        {
          name: 'OpenStreetMap',
          visible: false,
          attribution:
            '&copy; <a target="_blank" href="https://osm.org/copyright">OpenStreetMap</a> contributors',
          url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'
        }
      ],
      map: {
        center: L.latLng(-6.21011, 106.832459),
        zoom: 13
      },

      mapOptions: {
        minZoom: 2,
        zoomSnap: 0.5
      },

      tempId: '',
      input: {
        user_id: '',
        order_no: '',
        order_date: '',
        imei: '',
        driver_id: '',
        date_departure_planed: '',
        date_arrival_planed: '',
        route: '',
        customer: '',
        item: '',
        quantity: '',
        pickup_id: '',
        drop_id: '',
        note: ''
      },

      userList: [],
      deviceList: [],
      routeList: [],
      driverList: [],
      customerList: [],
      polylines: [],

      polygons_selected_pickup: [],
      markers_selected_pickup: [],
      polygons_selected_drop: [],
      markers_selected_drop: [],
      geom_pickup: [],
      geom_drop: [],

      action: '',

      page: 1,
      per_page: 10,
      row_total: 0,
      keyword: '',
      timer: null,
      loading: true,

      notify: 'Server Error',
      selected: [],
      showPopup: false,
      showPopupDetail: false,
      poiList_pickup: [],
      poiList_drop: [],

      statusList: [],

      dateList: [
        { value: '', label: 'Select Filter' },
        { value: 'today', label: 'Today' },
        { value: 'yesterday', label: 'Yesterday' },
        { value: 'define', label: 'Select Date' }
      ],

      filter: {
        device: '',
        start_date: null,
        end_date: null,
        status: '',
        dateOption: { value: '', label: 'Select Filter' }
      },

      filtered: {
        device: '',
        start_date: null,
        end_date: null,
        status: '',
        dateOption: { value: '', label: 'Select Filter' }
      },

      today: '',
      yesterday: '',
      twoDaysAgo: '',
      maxDate: '',
      disableDate: true,

      popupTitle: '',
      selected_status: '',
      color_status: ['', 'blue', 'teal', 'orange', 'purple', 'red', 'green'],

      show_detail: [],
      tempDevice: '',
      tempDriver: '',
      tempRoute: '',
      tempCustomer: '',
      tempPickupPoi: '',
      tempDropPoi: '',

      finish: {
        loading_date: '',
        depart_date: '',
        arrive_date: '',
        unloading_date: '',
        finish_date: ''
      },

      polylines_show: [],
      markers_pickup_show: [],
      polygons_pickup_show: [],
      markers_drop_show: [],
      polygons_drop_show: [],

      list_vehicle: []
    }
  },

  computed: {
    isSmallerScreen() {
      return this.$store.state.windowWidth < 992
    },

    isWider() {
      return this.$store.state.windowWidth >= 1440
    },

    n_page() {
      return Math.ceil(this.row_total / this.per_page)
    },

    user_id() {
      return this.input.user_id
    },

    route() {
      return this.input.route
    },

    pickup() {
      return this.input.pickup_id
    },

    drop() {
      return this.input.drop_id
    },

    dateOption() {
      return this.filter.dateOption ? this.filter.dateOption.value : ''
    }
  },

  watch: {
    page() {
      this.initTable()
    },

    isWider() {
      this.initTable()
    },

    user_id(val) {
      this.input.imei = ''

      if (val) {
        this.getRouteList()
        this.getCustomerList()
        this.getDriverList()
        this.getPoiLIst()
      }
    },

    route(val) {
      if (val) {
        this.polylines = [
          {
            latlngs: this.linestringToPolyline(val.geom),
            visible: true
          }
        ]

        this.map.center = this.polylines[0].latlngs[0]
        setTimeout(() => {
          this.map.zoom = 11
        }, 800)
      }
    },
    pickup(val) {
      if (val) {
        this.markers_selected_pickup = []
        this.polygons_selected_pickup = []

        const data = val
        if (data.type == 0) {
          this.markers_selected_pickup.push({
            name: data.label,
            latlngs: L.latLng(data.lat, data.lon),
            center: L.latLng(data.lat, data.lon),
            visible: true,
            slug: 'pickup',
            icon: data.icon
              ? L.icon({
                  iconUrl: `${
                    data.icon.fullpath_icon
                      ? data.icon.fullpath_icon
                      : data.icon.icon
                  }`,
                  iconSize: [20, 20]
                })
              : L.icon.Default
          })

          this.map.center = this.markers_selected_pickup[0].latlngs
        } else {
          this.polygons_selected_pickup.push({
            name: data.label,
            latlngs: this.geomToPolygon(data.geom),
            center: L.latLng(data.lat, data.lon),
            visible: true,
            slug: 'pickup'
          })

          this.map.center = this.polygons_selected_pickup[0].latlngs[0]
        }

        setTimeout(() => {
          this.map.zoom = 11
        }, 800)
      }
    },
    drop(val) {
      if (val) {
        this.markers_selected_drop = []
        this.polygons_selected_drop = []

        const data = val
        if (data.type == 0) {
          this.markers_selected_drop.push({
            name: data.label,
            latlngs: L.latLng(data.lat, data.lon),
            center: L.latLng(data.lat, data.lon),
            visible: true,
            slug: 'drop',
            icon: data.icon
              ? L.icon({
                  iconUrl: `${
                    data.icon.fullpath_icon
                      ? data.icon.fullpath_icon
                      : data.icon.icon
                  }`,
                  iconSize: [20, 20]
                })
              : L.icon.Default
          })

          this.map.center = this.markers_selected_drop[0].latlngs
        } else {
          this.polygons_selected_drop.push({
            name: data.label,
            latlngs: this.geomToPolygon(data.geom),
            center: L.latLng(data.lat, data.lon),
            visible: true,
            slug: 'drop'
          })

          this.map.center = this.polygons_selected_drop[0].latlngs[0]
        }
      }
      setTimeout(() => {
        this.map.zoom = 11
      }, 800)
    },

    dateOption() {
      let today = new Date()
      let yesterday = new Date(today)

      yesterday.setDate(yesterday.getDate() - 1)
      today = this.formatDate(today.toDateString())
      yesterday = this.formatDate(yesterday.toDateString())

      this.disableDate = true
      if (this.dateOption == 'today') {
        this.filter.start_date = this.today + ' 00:00'
        this.filter.end_date = this.today + ' 23:59'
        this.maxDate = this.today + ' 23:59'
      } else if (this.dateOption == 'yesterday') {
        this.filter.start_date = this.yesterday + ' 00:00'
        this.filter.end_date = this.yesterday + ' 23:59'
        this.maxDate = this.yesterday + ' 23:59'
      } else if (this.dateOption == 'define') {
        this.filter.start_date = ''
        this.filter.end_date = ''
        this.maxDate = this.today + ' 23:59'
        this.disableDate = false
      } else {
        this.filter.start_date = ''
        this.filter.end_date = ''
        this.maxDate = this.today + ' 23:59'
        // this.maxDate = this.twoDaysAgo + ' 23:59'
        // this.disableDate = false
      }
    }
  },

  created() {
    let today = new Date()
    let yesterday = new Date(today)
    let twoDaysAgo = new Date(today)

    yesterday.setDate(yesterday.getDate() - 1)
    twoDaysAgo.setDate(twoDaysAgo.getDate() - 2)

    this.today = this.formatDate(today.toDateString())
    this.yesterday = this.formatDate(yesterday.toDateString())
    this.twoDaysAgo = this.formatDate(twoDaysAgo.toDateString())

    this.token =
      localStorage.getItem('userInfo') !== null
        ? JSON.parse(localStorage.getItem('userInfo')).token
        : ''
    this.$http
      .get(`${this.$api.endpoint}/user/profile`, {
        headers: {
          Authorization: `Bearer ${this.token}`
        }
      })
      .then((res) => {
        this.actor = res.data.message.data

        if (this.actor.privilege == 4) {
          this.input.user_id = {
            label: this.actor.username,
            value: this.actor.id
          }
        }

        this.searchDevice('')
        this.selectStatus()
      })
      .catch((error) => {
        this.$gf.httpErrorHandler(error)
      })

    this.initTable()
  },

  mounted() {
    // window.addEventListener('keyup', e => {
    //   if(this.drawPolyline) {
    //     if(e.keyCode == 8) this.drawPolyline.editor.pop()
    //   }
    // })
    // this.$nextTick(() => {
    //   const map = this.$refs.map.mapObject
    //   map.editTools.on('editable:drawing:commit', (e) => {
    //     this.drawingTempData = this.polygonToGeom(e.vertex.latlngs)
    //   })
    //   map.editTools.on('editable:vertex:dragend', (e) => {
    //     this.drawingTempData = this.polygonToGeom(e.vertex.latlngs)
    //   })
    //   map.editTools.on('editable:vertex:ctrlclick', (e) => {
    //     e.vertex.continue()
    //   })
    //   map.editTools.on('editable:vertex:click', (e) => {
    //     if (this.action == 'edit') {
    //       e.vertex.delete()
    //       this.drawingTempData = this.polygonToGeom(e.vertex.latlngs)
    //     }
    //   })
    //   map.editTools.on('editable:vertex:shiftclick', (e) => {
    //     if (this.action == 'add') {
    //       e.vertex.delete()
    //       this.drawingTempData = this.polygonToGeom(e.vertex.latlngs)
    //     }
    //   })
    // })
  },

  methods: {
    formatDate(date) {
      var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear()

      if (month.length < 2) month = '0' + month
      if (day.length < 2) day = '0' + day

      return [year, month, day].join('-')
    },

    add() {
      this.action = 'add'
      this.reset()
    },

    cancel() {
      this.action = ''
      this.markers_selected_pickup = []
      this.polygons_selected_pickup = []
      this.markers_selected_drop = []
      this.polygons_selected_drop = []
      this.polylines = []
    },

    search() {
      if (this.timer) {
        clearTimeout(this.timer)
        this.timer = null
      }
      this.timer = setTimeout(() => {
        this.page = 1
        this.initTable()
      }, 800)
    },

    searchGeneral(search) {
      if (search.length >= 3) {
        this.$http
          .get(`${this.$api.endpoint}/user/general`, {
            headers: {
              Authorization: `Bearer ${this.token}`
            },
            params: {
              search: search
            }
          })
          .then((res) => {
            this.userList = res.data.message.data
          })
          .catch((error) => {
            this.$gf.httpErrorHandler(error)
          })
      } else {
        this.userList = []
      }
    },

    searchDevice(keyword) {
      if (this.actor.privilege >= 4) {
        this.getDataDevice(keyword)
      } else {
        if (keyword.length >= 3) {
          this.getDataDevice(keyword)
        } else {
          this.deviceList = []
        }
      }
    },

    getDataDevice(keyword) {
      this.$http
        .get(
          `${this.$api.endpoint}/tracking/search?keyword=${keyword}&type=vehicle`,
          {
            headers: {
              Authorization: `Bearer ${this.token}`
            }
          }
        )
        .then((res) => {
          this.deviceList = res.data.message.data

          if (this.tempDevice) {
            this.input.imei = this.deviceList.find((item) => {
              return item.value === this.tempDevice
            })
          }
        })
        .catch((error) => {
          this.$gf.httpErrorHandler(error)
        })
    },

    selectStatus() {
      this.$http
        .get(`${this.$api.endpoint}/job_order/order/select_status`, {
          headers: {
            Authorization: `Bearer ${this.token}`
          }
        })
        .then((res) => {
          this.statusList = res.data.message.data
        })
        .catch((error) => {
          this.$gf.httpErrorHandler(error)
        })
    },

    getRouteList() {
      this.$http
        .get(`${this.$api.endpoint}/job_order/route/select`, {
          params: {
            user_id: this.input.user_id ? this.input.user_id.value : ''
          },
          headers: {
            Authorization: `Bearer ${this.token}`
          }
        })
        .then((res) => {
          this.routeList = res.data.message.data

          if (this.tempRoute) {
            this.input.route = this.routeList.find((item) => {
              return item.value === this.tempRoute
            })
          }
        })
        .catch((error) => {
          this.$gf.httpErrorHandler(error)
        })
    },

    getCustomerList() {
      this.$http
        .get(`${this.$api.endpoint}/job_order/customer/select`, {
          params: {
            user_id: this.input.user_id ? this.input.user_id.value : ''
          },
          headers: {
            Authorization: `Bearer ${this.token}`
          }
        })
        .then((res) => {
          this.customerList = res.data.message.data

          if (this.tempCustomer) {
            this.input.customer = this.customerList.find((item) => {
              return item.value === this.tempCustomer
            })
          }
        })
        .catch((error) => {
          this.$gf.httpErrorHandler(error)
        })
    },

    getDriverList() {
      this.$http
        .get(`${this.$api.endpoint}/job_order/driver/select`, {
          params: {
            user_id: this.input.user_id ? this.input.user_id.value : ''
          },
          headers: {
            Authorization: `Bearer ${this.token}`
          }
        })
        .then((res) => {
          this.driverList = res.data.message.data

          if (this.tempDriver) {
            this.input.driver_id = this.driverList.find((item) => {
              return item.value === this.tempDriver
            })
          }
        })
        .catch((error) => {
          this.$gf.httpErrorHandler(error)
        })
    },

    detail(data) {
      this.tempId = data.id
      this.action = 'detail'

      this.userList.push({ value: data.user.id, label: data.user.username })
      this.input.user_id = { value: data.user.id, label: data.user.username }

      this.tempDevice = data.imei
      if (this.actor.privilege <= 3) this.getDataDevice(data.imei)
      else this.getDataDevice('')

      this.tempDriver = data.driver_id
      this.getDriverList()

      this.tempRoute = data.route_id
      this.getRouteList()

      this.tempCustomer = data.customer_id
      this.getCustomerList()

      this.tempPickupPoi = data.pickup_id
      this.tempDropPoi = data.drop_id
      this.getPoiLIst()

      this.input.order_no = data.order_no
      this.input.order_date = data.order_date
      this.input.date_departure_planed = data.date_departure_planed
      this.input.date_arrival_planed = data.date_arrival_planed
      this.input.item = data.item
      this.input.quantity = data.quantity
      this.input.note = data.note
    },

    del(id) {
      this.tempId = id
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: `Delete Route`,
        text: 'Are you sure want to Delete this Route ?',
        accept: this.confirmDelete
      })
    },

    confirmDelete() {
      this.$http
        .post(
          `${this.$api.endpoint}/job_order/order_single/delete/${this.tempId}`,
          {},
          {
            headers: {
              Authorization: `Bearer ${this.token}`
            }
          }
        )
        .then((res) => {
          this.notify = res.data.message.split('_').join(' ')
          this.initTable()

          this.$vs.notify({
            title: 'Thank You',
            text: this.notify,
            color: 'success',
            position: 'top-right'
          })
        })
        .catch((error) => {
          this.$gf.httpErrorHandler(error)
        })
    },

    submit() {
      this.$vs.loading({
        background: 'success',
        color: '#fff',
        container: '#submitBtn',
        scale: 0.45
      })

      let url =
        this.action === 'add'
          ? `${this.$api.endpoint}/job_order/order_single/add`
          : `${this.$api.endpoint}/job_order/order_single/update/${this.tempId}`

      this.$http
        .post(
          url,
          {
            user_id: this.input.user_id ? this.input.user_id.value : null,
            order_no: this.input.order_no,
            order_date:
              this.input.order_date.length < 19
                ? `${this.input.order_date}:00`
                : this.input.order_date,
            imei: this.input.imei ? this.input.imei.value : null,
            driver_id: this.input.driver_id ? this.input.driver_id.value : null,

            date_departure_planed:
              this.input.date_departure_planed.length >= 19
                ? this.input.date_departure_planed
                : this.input.date_departure_planed != ''
                ? `${this.input.date_departure_planed}:00`
                : null,

            date_arrival_planed:
              this.input.date_arrival_planed.length >= 19
                ? this.input.date_arrival_planed
                : this.input.date_arrival_planed != ''
                ? `${this.input.date_arrival_planed}:00`
                : null,

            route: this.input.route ? this.input.route.value : null,
            customer: this.input.customer ? this.input.customer.value : null,
            item: this.input.item,
            quantity: this.input.quantity,
            pickup_id: this.input.pickup_id ? this.input.pickup_id.value : null,
            drop_id: this.input.drop_id ? this.input.drop_id.value : null,
            pickup_type: this.input.pickup_id
              ? this.input.pickup_id.type
              : null,
            drop_type: this.input.drop_id ? this.input.drop_id.type : null,
            geom_pickup: this.input.pickup_id
              ? this.input.pickup_id.geom
              : null,
            geom_drop: this.input.drop_id ? this.input.drop_id.geom : null,
            note: this.input.note
          },
          {
            headers: {
              Authorization: `Bearer ${this.token}`
            }
          }
        )
        .then((res) => {
          this.cancel()
          this.$vs.loading.close('#submitBtn > .con-vs-loading')

          this.initTable()

          this.markers_selected_pickup = []
          this.polygons_selected_pickup = []
          this.markers_selected_drop = []
          this.polygons_selected_drop = []

          this.notify = res.data.message.split('_').join(' ')
          this.$vs.notify({
            title: 'Thank You',
            text: this.notify,
            color: 'success',
            position: 'top-right'
          })
        })
        .catch((error) => {
          this.$vs.loading.close('#submitBtn > .con-vs-loading')
          this.$gf.httpErrorHandler(error)
        })
    },

    reset() {
      this.input.order_no = ''
      this.input.order_date = ''
      this.input.imei = ''
      this.input.driver_id = ''
      this.input.date_departure_planed = ''
      this.input.date_arrival_planed = ''
      this.input.route = ''
      this.input.customer = ''
      this.input.item = ''
      this.input.quantity = ''
      this.input.pickup_id = ''
      this.input.drop_id = ''
      this.input.pickup_type = ''
      this.input.drop_type = ''
      this.input.geom_pickup = ''
      this.input.geom_drop = ''
      this.input.note = ''

      this.tempDevice = ''
      this.tempDriver = ''
      this.tempRoute = ''
      this.tempCustomer = ''
      this.tempPickupPoi = ''
      this.tempDropPoi = ''

      this.getDataDevice('')
      this.getDriverList()
      this.getRouteList()
      this.getCustomerList()
      this.getPoiLIst()
    },

    check(item, event) {
      let visible = event.target.checked

      //TODO ============= PROCESS CHEKED SHOW VEHICLE ==============

      if (!visible) {
        this.list_vehicle = this.list_vehicle.filter((i) => {
          return i.id != item.id
        })
      } else {
        this.$http
          .get(`${this.$api.endpoint}/gps/detail/${item.imei}`, {
            headers: {
              Authorization: `Bearer ${this.token}`
            }
          })
          .then((res) => {
            const data = res.data.message.data

            this.list_vehicle.push({
              id: item.id,
              name: data.plate,
              imei: data.imei,
              latlngs: L.latLng(data.lat, data.lon),
              center: L.latLng(data.lat, data.lon),
              visible: visible,
              icon: data.icon
                ? L.icon({
                    iconUrl: `${
                      data.fullpath_icon
                        ? data.fullpath_icon.acc_on
                        : data.icon.acc_on
                    }`,
                    iconSize: [40, 40]
                  })
                : L.icon.Default
            })
          })
      }

      //TODO ============= PROCESS CHEKED SHOW ROUTE ==============

      if (!visible) {
        this.polylines_show = this.polylines_show.filter((i) => {
          return i.id != item.id
        })
      } else {
        if (item.geom_route != null) {
          let latlngs = this.linestringToPolyline(item.geom_route)
          this.polylines_show.push({
            id: item.id,
            name: item.route.name,
            latlngs: latlngs,
            color: 'purple',
            visible: visible
          })
        }
      }

      //TODO ============= PROCESS CHEKED SHOW PICKUP POLYGONE AND MARKER ==============

      let target_pickup =
        item.pickup.type === 0 ? 'markers_pickup_show' : 'polygons_pickup_show'
      let latlngs_pickup =
        item.pickup.type === 0
          ? L.latLng(item.pickup.lat, item.pickup.lon)
          : this.geomToPolygon(item.geom_pickup)

      if (!visible) {
        this[target_pickup] = this[target_pickup].filter((i) => {
          return i.id != item.id
        })
      } else {
        this[target_pickup].push({
          id: item.id,
          name: `Pickup Point (${item.pickup.name})`,
          latlngs: latlngs_pickup,
          center: L.latLng(item.pickup.lat, item.pickup.lon),
          visible: visible,
          icon: item.pickup.icon
            ? L.icon({
                iconUrl: `${
                  item.pickup.icon.fullpath_icon
                    ? item.pickup.icon.fullpath_icon
                    : item.pickup.icon.icon
                }`,
                iconSize: [30, 30]
              })
            : L.icon.Default
        })
      }

      //TODO ============= PROCESS CHEKED SHOW DROP POLYGONE AND MARKER ==============

      let target_drop =
        item.drop.type === 0 ? 'markers_drop_show' : 'polygons_drop_show'
      let latlngs_drop =
        item.drop.type === 0
          ? L.latLng(item.drop.lat, item.drop.lon)
          : this.geomToPolygon(item.geom_drop)

      if (!visible) {
        this[target_drop] = this[target_drop].filter((i) => {
          return i.id != item.id
        })
      } else {
        this[target_drop].push({
          id: item.id,
          name: `Drop Point (${item.drop.name})`,
          latlngs: latlngs_drop,
          center: L.latLng(item.drop.lat, item.drop.lon),
          visible: visible,
          icon: item.drop.icon
            ? L.icon({
                iconUrl: `${
                  item.drop.icon.fullpath_icon
                    ? item.drop.icon.fullpath_icon
                    : item.drop.icon.icon
                }`,
                iconSize: [30, 30]
              })
            : L.icon.Default
        })
      }

      this.map.center = L.latLng(item.pickup.lat, item.pickup.lon)
      this.map.zoom = 13

      if (this.polylines_show.length == 0) this.list_vehicle = []
    },

    initTable() {
      if (!this.isWider) this.per_page = 5
      else this.per_page = 10

      this.$http
        .get(`${this.$api.endpoint}/job_order/order_single/datatable`, {
          headers: {
            Authorization: `Bearer ${this.token}`
          },
          params: {
            page: this.page,
            per_page: this.per_page,
            search: this.keyword,
            device: this.filter.device ? this.filter.device.value : '',
            date_option: this.dateOption,
            start_date: this.filter.start_date
              ? this.filter.start_date + ':00'
              : '',
            end_date: this.filter.end_date ? this.filter.end_date + ':00' : '',
            status: this.filter.status ? this.filter.status.value : ''
          }
        })
        .then((res) => {
          this.row_total = res.data.message.total
          this.data = res.data.message.data
          this.loading = false

          this.polylines_show = []
          this.markers_pickup_show = []
          this.polygons_pickup_show = []
          this.markers_drop_show = []
          this.polygons_drop_show = []
          this.list_vehicle = []
          this.selected = []
        })
        .catch((error) => {
          this.$gf.httpErrorHandler(error)
        })
    },

    linestringToPolyline(geom) {
      let start = '('
      let end = ')'

      geom = geom.substring(
        geom.indexOf(start) + start.length,
        geom.indexOf(end)
      )

      let latlon = geom.split(',')

      let result = []
      latlon.map((item) => {
        let x = item.split(' ')
        result.push([parseFloat(x[1]), parseFloat(x[0])])
      })

      return result
    },

    getPoiLIst() {
      this.poiList_pickup = []
      this.poiList_drop = []

      this.$http
        .get(`${this.$api.endpoint}/poi/datapoi`, {
          params: {
            user_id: this.input.user_id ? this.input.user_id.value : ''
          },
          headers: {
            Authorization: `Bearer ${this.token}`
          }
        })
        .then((res) => {
          let tempData = res.data.message.data

          this.poiList_pickup = tempData
          if (this.tempPickupPoi != '') {
            this.input.pickup_id = this.poiList_pickup.find((item) => {
              return item.value === this.tempPickupPoi
            })
          }

          this.poiList_drop = tempData
          if (this.tempDropPoi != '') {
            this.input.drop_id = this.poiList_drop.find((item) => {
              return item.value === this.tempDropPoi
            })
          }
        })
        .catch((error) => {
          this.$gf.httpErrorHandler(error)
        })
    },

    geomToPolygon(geom) {
      let start = '(('
      let end = '))'

      geom = geom.substring(
        geom.indexOf(start) + start.length,
        geom.indexOf(end)
      )

      let latlon = geom.split(',')

      let result = []
      latlon.map((item) => {
        let x = item.split(' ')
        result.push([parseFloat(x[1]), parseFloat(x[0])])
      })

      return result
    },

    lihat() {
      console.log(this.input.details[0].polygons)
    },

    polygonToGeom(polygon) {
      let lonlat = ''
      polygon.map((item, index) => {
        // if(index > 0) lonlat += ', '
        if (index === 0)
          lonlat += `${item.lng} ${item.lat}, ${item.lng} ${item.lat}`
        else lonlat += `, ${item.lng} ${item.lat}`
      })

      lonlat += `, ${polygon[0].lng} ${polygon[0].lat}`

      return `POLYGON ((${lonlat}))`
    },

    polygonToGeom2(polygon) {
      let lonlat = ''
      let item = polygon.value

      for (let i = 0; i < item.length; i++) {
        if (i === 0)
          lonlat += `${item[i][1]} ${item[i][0]}, ${item[i][1]} ${item[i][0]}`
        else lonlat += `, ${item[i][1]} ${item[i][0]}`
      }

      return `POLYGON ((${lonlat}))`
    },

    pointToGeom(data, trash) {
      while (~trash.indexOf(data[0])) {
        data = data.slice(1)
      }
      while (~trash.indexOf(data[data.length - 1])) {
        data = data.slice(0, -1)
      }
      return data
    },

    finish_time(data) {
      this.tempId = data.id

      this.finish.loading_date = data.date_loading
      this.finish.depart_date = data.date_departure
      this.finish.arrive_date = data.date_arrival
      this.finish.unloading_date = data.date_unloading
      this.finish.finish_date = data.date_finish

      this.popupTitle = 'Finish Time'
      this.showPopup = true
    },

    updateFinishTime() {
      this.$vs.loading({
        background: 'success',
        color: '#fff',
        container: '#submitBtn',
        scale: 0.45
      })

      let url = `${this.$api.endpoint}/job_order/order_single/update_finish_time/${this.tempId}`

      this.$http
        .post(
          url,
          {
            date_loading:
              this.finish.loading_date.length >= 19
                ? this.finish.loading_date
                : this.finish.loading_date != ''
                ? `${this.finish.loading_date}:00`
                : null,

            date_departure:
              this.finish.depart_date.length >= 19
                ? this.finish.depart_date
                : this.finish.depart_date != ''
                ? `${this.finish.depart_date}:00`
                : null,

            date_arrival:
              this.finish.arrive_date.length >= 19
                ? this.finish.arrive_date
                : this.finish.arrive_date != ''
                ? `${this.finish.arrive_date}:00`
                : null,

            date_unloading:
              this.finish.unloading_date.length >= 19
                ? this.finish.unloading_date
                : this.finish.unloading_date != ''
                ? `${this.finish.unloading_date}:00`
                : null,

            date_finish:
              this.finish.finish_date.length >= 19
                ? this.finish.finish_date
                : this.finish.finish_date != ''
                ? `${this.finish.finish_date}:00`
                : null
          },
          {
            headers: {
              Authorization: `Bearer ${this.token}`
            }
          }
        )
        .then((res) => {
          this.cancel()
          this.$vs.loading.close('#submitBtn > .con-vs-loading')

          this.initTable()

          this.notify = res.data.message.split('_').join(' ')
          this.$vs.notify({
            title: 'Thank You',
            text: this.notify,
            color: 'success',
            position: 'top-right'
          })

          this.showPopup = false
        })
        .catch((error) => {
          this.$vs.loading.close('#submitBtn > .con-vs-loading')
          this.$gf.httpErrorHandler(error)
        })
    }
  }
}
</script>
